import React, { useEffect, useState } from 'react';
import AsyncCreatable from 'react-select/async-creatable';

import { getData } from '../helper/request-response';
import constant from '../config/constant';

const Select = ({ api, paramFilter, entityId, textFilter, value, onChange }) => {

    const [option, setOption] = useState([]); 

    const [filter, setFilter] = useState('keyword');

    const [field, setField] = useState('label');

    /**
     * Filter the option.
     * @param {string} val - String to search.
     */
    const filterOption = (val) => {

        return option.filter(o => o[field].toLowerCase().includes(val.toLowerCase()));

    }

    /**
     * Get source data from the database filtered by val.
     * @param {string} val - String to search.
     */
    const getSourceData = val => new Promise((resolve) => {

        const getResult = async() => {

            const param = {
                params: { 
                    [filter]: val,
                    'entity-id': entityId
                }
            };
    
            const result = await getData(api, param);

            return result;
        }

        const result = getResult();

        resolve(result);
    });

    /**
     * Filter the autocomplete option when user typing the val.
     * @param {string} val - String to search.
     */
    const asyncOption = val => new Promise((resolve) => {

        getSourceData(val).then(data => {

            setOption(data);

            resolve(filterOption(val));

        });
    });

    /**
     * Run only once.
     */
    useEffect(() => {

        getSourceData('').then(data => {

            setOption(data);

        });

        // eslint-disable-next-line
    }, []);

    /**
     * Run every keyword property changed.
     */
    useEffect(() => {

        if (paramFilter) setFilter(paramFilter);

        if (textFilter) setField(textFilter);

    }, [paramFilter, textFilter]);

    return (
        <AsyncCreatable
            cacheOptions
            defaultOptions={ option }
            loadOptions={ asyncOption }
            onChange={ opt => onChange(opt) }
            value={ value }
            formatCreateLabel={ keyword => `${constant.NO_RESULT_TEXT_ADD} ${keyword}` }
        />
    )

}

export default Select;
